import { FiTrash } from 'react-icons/fi'

import { t } from 'i18next'

import { Button } from '~/components/Buttons'
import { Badge } from '~/components/UI/Badge'
import { isReadOnly } from '~/helpers'

type AdSizeTableSchema = (props: AdSizeTableSchemaProps) => TableSchema<AdSize>

type AdSizeTableSchemaProps = {
  formData: AdSizeFormData
  onDelete: (id: string) => void
  isPending: boolean
}

export const adSizeTableSchema: AdSizeTableSchema = ({
  formData,
  onDelete,
  isPending
}) => {
  const actionColumn: TableSchema<AdSize> = {
    actions: {
      render: rowData => (
        <Button
          template="transparentCritical"
          onClick={() => onDelete(rowData.id)}
          loading={isPending}
          disabled={isPending}
          customWidth="auto"
          size="xsmall"
        >
          <FiTrash />
        </Button>
      )
    }
  }

  const handleActionColumn = isReadOnly() ? null : actionColumn

  const isSameSize = (rowData: AdSize) =>
    formData?.width === rowData.width &&
    formData?.height === rowData.height &&
    formData?.type === rowData.type

  const getBadgeTemplate = (rowData: AdSize) =>
    isSameSize(rowData) ? 'successSolid' : 'primary'

  return {
    id: {
      title: t('rm:adsize.list.table.column.title.id'),
      helpText: t('rm:adsize.list.table.column.helpText.id'),
      render: rowData => rowData.name
    },
    name: {
      title: t('rm:adsize.list.table.column.title.name'),
      helpText: t('rm:adsize.list.table.column.helpText.name'),
      render: rowData => rowData.label
    },
    type: {
      title: t('rm:adsize.list.table.column.title.type'),
      helpText: t('rm:adsize.list.table.column.helpText.type'),
      render: rowData =>
        rowData.type ? t(`rm:adsize.form.text.type.${rowData.type}`) : '-'
    },
    dimensions: {
      title: t('rm:adsize.list.table.column.title.dimensions'),
      helpText: t('rm:adsize.list.table.column.helpText.dimensions'),
      render: rowData => (
        <span className="d-flex align-items-center text-nowrap gap-1">
          <Badge template={getBadgeTemplate(rowData)} className="m-0">
            <code>{rowData.width}px</code>
          </Badge>
          <code>x</code>
          <Badge template={getBadgeTemplate(rowData)} className="m-0">
            <code>{rowData.height}px</code>
          </Badge>
        </span>
      )
    },
    ...handleActionColumn
  }
}
